import { cn } from '@taskflow/ui';

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  className?: string;
}

const MARK_SIZES = { sm: 'size-6', md: 'size-8', lg: 'size-12' } as const;
const TEXT_SIZES = { sm: 'text-sm', md: 'text-base', lg: 'text-xl' } as const;

/**
 * Brand lockup.
 *
 * PLACEHOLDER MARK — the geometric shape below stands in for the Cuddles
 * Foundation logo until Akash supplies the SVG. It is drawn from brand tokens so
 * it never looks out of place, and swapping in the real asset is a change to this
 * one file.
 */
export function Logo({ size = 'md', showWordmark = true, className }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 32 32"
        className={cn('shrink-0', MARK_SIZES[size])}
        role="img"
        aria-label="Cuddles Foundation"
      >
        <circle cx="12" cy="9" r="6" fill="var(--color-orange-500)" />
        <path
          d="M3 26c0-7 5.5-12 12-12 3 0 5.5 1 7.5 2.8 1.5 1.4.6 3.9-1.4 3.9H10c-2.5 0-4 1.8-4 4v1.3C6 27 4.8 28 3.6 28 3.3 28 3 27.7 3 27.4V26Z"
          fill="var(--color-orange-500)"
        />
        <circle cx="24" cy="17" r="4.5" fill="var(--color-orange-400)" />
      </svg>

      {showWordmark ? (
        <span className={cn('font-semibold tracking-tight text-text-primary', TEXT_SIZES[size])}>
          TaskFlow
        </span>
      ) : null}
    </span>
  );
}
